<template>
  <div v-loading="scanned" element-loading-text="正在登录跳转中...">
    <iframe
      :src="qrcodeUrl"
      :width="width"
      :height="height"
      frameborder="0"
      allowtransparency="true"
      scrolling="no"
    ></iframe>
  </div>
</template>
<script>
// import { _post } from '@/utils/http';
// import lockr from 'lockr';

export default {
  name: 'DingQrLogin',
  props: {
    appid: { // 钉钉后台配置的app_id
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: 'STATE',
    },
    loginUrl: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 365,
    },
    height: {
      type: Number,
      default: 400,
    },
    innerStyle: {
      type: String,
      default: '',
    },
    innerHref: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      loginTmpCode: '',
    };
  },
  computed: {
    scanned() {
      return !!this.$route.query.code;
    },
    gotoUrl() {
      return `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.appid}&response_type=code&scope=snsapi_login&state=${this.state}&redirect_uri=${encodeURIComponent(this.loginUrl)}`;
    },
    qrcodeUrl() {
      let url = `https://login.dingtalk.com/login/qrcode.htm?goto=${encodeURIComponent(this.gotoUrl)}`;
      if (this.innerStyle) {
        url += `&style=${encodeURIComponent(this.innerStyle)}`;
      }
      if (this.innerHref) {
        url += `&href=${encodeURIComponent(this.innerHref)}`;
      }
      return url;
    },
  },
  methods: {
  },
  mounted() {
    // 处理 dd 事件
    const handleReceiveTempCode = ((event) => {
      let origin = event.origin;
      // console.log('origin', event.origin);
      if (origin === 'https://login.dingtalk.com') { // 判断是否来自ddLogin扫码事件。
        this.loginTmpCode = event.data;
        // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        // alert(`${this.gotoUrl}&loginTmpCode=${this.loginTmpCode}`);
        window.location = `${this.gotoUrl}&loginTmpCode=${this.loginTmpCode}`;
        // console.log('loginTmpCode', this.loginTmpCode);

        // 发出事件
        // this.$emit('success', this.loginTmpCode);
      }
    });

    // 创建 dd 事件监听
    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', handleReceiveTempCode, false);
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', handleReceiveTempCode);
    }
  },
  created() {
  },
  beforeCreate() {
  }
};
</script>

<style>
</style>
